export default {
  elements: [
    {
      type: 'rectangle',
      version: 221,
      versionNonce: 916426177,
      isDeleted: false,
      id: 'oDVXy8D6rom3H1-LLH2-f',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'dotted',
      roughness: 2,
      opacity: 100,
      angle: 0,
      x: 414.50390625,
      y: 95.67578125,
      strokeColor: '#000000',
      backgroundColor: '#868e96',
      width: 186.47265625,
      height: 141.9765625,
      seed: 234619535,
      groupIds: [],
      strokeSharpness: 'round',
      boundElements: [],
      updated: 1654508655603,
      link: null,
    },
    {
      type: 'ellipse',
      version: 56,
      versionNonce: 577205857,
      isDeleted: true,
      id: '-xMIs_0jIFqvpx-R9UnaG',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      angle: 0,
      x: 300.5703125,
      y: 190.69140625,
      strokeColor: '#000000',
      backgroundColor: 'transparent',
      width: 198.21875,
      height: 129.51171875,
      seed: 957947807,
      groupIds: [],
      strokeSharpness: 'sharp',
      boundElements: [],
      updated: 1654508559248,
      link: null,
    },
    {
      type: 'image',
      version: 152,
      versionNonce: 851074095,
      isDeleted: true,
      id: 'sWYdvFk3dGOd_pnInTHHz',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      angle: 0,
      x: 606.1042326312408,
      y: 153.57729779411773,
      strokeColor: 'transparent',
      backgroundColor: 'transparent',
      width: 231.30325348751828,
      height: 231.64340533088227,
      seed: 707269846,
      groupIds: [],
      strokeSharpness: 'round',
      boundElements: [],
      updated: 1654508559248,
      link: null,
      status: 'pending',
      fileId: 'rocket',
      scale: [1, 1],
    },
    {
      type: 'ellipse',
      version: 24,
      versionNonce: 835453505,
      isDeleted: true,
      id: 'qy46TlF50W6kgDYyFrYlX',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      angle: 0,
      x: 857,
      y: 106,
      strokeColor: '#000000',
      backgroundColor: 'transparent',
      width: 259,
      height: 119,
      seed: 1104497038,
      groupIds: [],
      strokeSharpness: 'sharp',
      boundElements: [],
      updated: 1654508559248,
      link: null,
    },
    {
      type: 'ellipse',
      version: 21,
      versionNonce: 580714063,
      isDeleted: true,
      id: 'X7mfE2VCs4uc9_pZI52lQ',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      angle: 0,
      x: 445,
      y: 93,
      strokeColor: '#000000',
      backgroundColor: 'transparent',
      width: 86,
      height: 52,
      seed: 847449746,
      groupIds: [],
      strokeSharpness: 'sharp',
      boundElements: [],
      updated: 1654508559248,
      link: null,
    },
    {
      type: 'text',
      version: 109,
      versionNonce: 544477729,
      isDeleted: true,
      id: 'D7XW76zdrEtEFQbY2W9G9',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 90,
      angle: 0,
      x: 440,
      y: 116,
      strokeColor: '#e67700',
      backgroundColor: 'transparent',
      width: 141,
      height: 40,
      seed: 45945934,
      groupIds: [],
      strokeSharpness: 'sharp',
      boundElements: [],
      updated: 1654508559248,
      link: null,
      fontSize: 28,
      fontFamily: 1,
      text: '欢迎使用！',
      baseline: 30,
      textAlign: 'center',
      verticalAlign: 'top',
      containerId: null,
      originalText: '欢迎使用！',
    },
    {
      id: 'CxfxLPqTKvkbZoqDjUrT4',
      type: 'text',
      x: 433,
      y: 138,
      width: 66,
      height: 28,
      angle: 0,
      strokeColor: '#e67700',
      backgroundColor: 'transparent',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      groupIds: [],
      strokeSharpness: 'sharp',
      seed: 1030149775,
      version: 107,
      versionNonce: 1557486433,
      isDeleted: false,
      boundElements: null,
      updated: 1654508617309,
      link: null,
      text: '1、单击',
      fontSize: 20,
      fontFamily: 1,
      textAlign: 'left',
      verticalAlign: 'top',
      baseline: 21,
      containerId: null,
      originalText: '1、单击',
    },
    {
      id: 'DHWvA0mKBH44MorgN0eVr',
      type: 'text',
      x: 510,
      y: 155,
      width: 41,
      height: 28,
      angle: 0,
      strokeColor: '#000000',
      backgroundColor: '#868e96',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      groupIds: [],
      strokeSharpness: 'sharp',
      seed: 527946497,
      version: 68,
      versionNonce: 1129260545,
      isDeleted: true,
      boundElements: null,
      updated: 1654508559248,
      link: null,
      text: '编辑',
      fontSize: 20,
      fontFamily: 1,
      textAlign: 'left',
      verticalAlign: 'top',
      baseline: 21,
      containerId: null,
      originalText: '编辑',
    },
    {
      id: 'NOnyQLED3pHfOpE-5fNkF',
      type: 'text',
      x: 429,
      y: 171,
      width: 76,
      height: 28,
      angle: 0,
      strokeColor: '#e67700',
      backgroundColor: '#868e96',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      groupIds: [],
      strokeSharpness: 'sharp',
      seed: 1127911663,
      version: 173,
      versionNonce: 724574945,
      isDeleted: false,
      boundElements: null,
      updated: 1654508627757,
      link: null,
      text: '2、双击',
      fontSize: 20,
      fontFamily: 1,
      textAlign: 'left',
      verticalAlign: 'top',
      baseline: 21,
      containerId: null,
      originalText: '2、双击',
    },
    {
      id: 'GNXiynfrLw-chi82UnR40',
      type: 'text',
      x: 419.50390625,
      y: 154.1640625,
      width: 176,
      height: 25,
      angle: 0,
      strokeColor: '#c92a2a',
      backgroundColor: '#868e96',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      groupIds: [],
      strokeSharpness: 'sharp',
      seed: 2023986735,
      version: 11,
      versionNonce: 427248623,
      isDeleted: true,
      boundElements: null,
      updated: 1654508558663,
      link: null,
      text: '进行拖拽',
      fontSize: 20,
      fontFamily: 1,
      textAlign: 'center',
      verticalAlign: 'middle',
      baseline: 18,
      containerId: 'oDVXy8D6rom3H1-LLH2-f',
      originalText: '进行拖拽',
    },
    {
      id: 'W0DHRrbnRRPZTsReS4SUE',
      type: 'text',
      x: 419.50390625,
      y: 154.1640625,
      width: 176,
      height: 25,
      angle: 0,
      strokeColor: '#c92a2a',
      backgroundColor: '#868e96',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      groupIds: [],
      strokeSharpness: 'sharp',
      seed: 1639363343,
      version: 21,
      versionNonce: 626834913,
      isDeleted: true,
      boundElements: null,
      updated: 1654508559248,
      link: null,
      text: '进行编辑',
      fontSize: 20,
      fontFamily: 1,
      textAlign: 'center',
      verticalAlign: 'middle',
      baseline: 18,
      containerId: 'oDVXy8D6rom3H1-LLH2-f',
      originalText: '进行编辑',
    },
    {
      type: 'text',
      version: 202,
      versionNonce: 673917537,
      isDeleted: false,
      id: 'H2g0aCN7qHGu5ffi6gRN4',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      angle: 0,
      x: 503,
      y: 138,
      strokeColor: '#000000',
      backgroundColor: 'transparent',
      width: 81,
      height: 28,
      seed: 2100289231,
      groupIds: [],
      strokeSharpness: 'sharp',
      boundElements: [],
      updated: 1654508635036,
      link: null,
      fontSize: 20,
      fontFamily: 1,
      text: '进行拖拽',
      baseline: 21,
      textAlign: 'left',
      verticalAlign: 'top',
      containerId: null,
      originalText: '进行拖拽',
    },
    {
      type: 'text',
      version: 214,
      versionNonce: 794533537,
      isDeleted: false,
      id: 'z9MIow-6IbD9Msk9vgNlp',
      fillStyle: 'hachure',
      strokeWidth: 1,
      strokeStyle: 'solid',
      roughness: 1,
      opacity: 100,
      angle: 0,
      x: 506,
      y: 171,
      strokeColor: '#000000',
      backgroundColor: '#868e96',
      width: 81,
      height: 28,
      seed: 506062287,
      groupIds: [],
      strokeSharpness: 'sharp',
      boundElements: [],
      updated: 1654508631470,
      link: null,
      fontSize: 20,
      fontFamily: 1,
      text: '进行编辑',
      baseline: 21,
      textAlign: 'left',
      verticalAlign: 'top',
      containerId: null,
      originalText: '进行编辑',
    },
  ],
};
